import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Abouts } from '../components/Abouts';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';

export const About = (): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Title.About');
  }, [t]);

  return (
    <>
      <Header />
      <Abouts />
      <Footer />
    </>
  );
};
